import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'generic-confirmation-dialog',
  templateUrl: 'generic-confirmation-dialog.component.html',
  styleUrls: ['generic-confirmation-dialog.component.scss'],
})
export class GenericConfirmationDialogComponent {
  public action: string;
  constructor(
    public dialogRef: MatDialogRef<GenericConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string,
      message: string,
      abortText: string,
      proceedText: string,
      dangerMode?: boolean
    }) { }
}

